module.exports = __webpack_public_path__ + "static/media/office_6.511ada2d.jpg";